import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Building2, LineChart, ShieldCheck, Sprout } from "lucide-react";

const Legal = () => {
  const { t } = useLang();
  const l = t.legal;

  const sections = [
    { icon: Building2, title: l.legalinfo_s1_title, body: l.legalinfo_s1, color: "bg-[#1E4D2B]" },
    { icon: LineChart, title: l.legalinfo_s2_title, body: l.legalinfo_s2, color: "bg-[#F59E0B]" },
    { icon: ShieldCheck, title: l.legalinfo_s3_title, body: l.legalinfo_s3, color: "bg-[#14361E]" },
  ];

  return (
    <div data-testid="legal-page" className="bg-[#FDFBF7]">
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-stone-200 bg-gradient-to-b from-[#F4F1EA] to-[#FDFBF7]">
        <div className="container-gc px-4 sm:px-6 py-14 sm:py-20 relative">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-stone-200 text-xs font-medium text-[#1E4D2B] mb-5">
              <Sprout size={14} /> {t.brand}
            </div>
            <h1 data-testid="legal-title" className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 leading-tight">
              {l.legalinfo_title}
            </h1>
            <p className="mt-5 text-lg text-stone-700 leading-relaxed max-w-2xl">{l.legalinfo_intro}</p>
            <div className="mt-4 text-sm text-stone-500">{l.last_updated}</div>
          </div>
        </div>
      </section>

      {/* Sections */}
      <section className="section-pad">
        <div className="container-gc max-w-4xl grid gap-5">
          {sections.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={i}
                data-testid={`legal-section-${i}`}
                className="card-gc p-6 sm:p-7 flex flex-col sm:flex-row gap-5 hover:shadow-md transition-shadow"
              >
                <div className={`w-12 h-12 rounded-xl ${s.color} text-white flex items-center justify-center flex-shrink-0`}>
                  <Icon size={22} />
                </div>
                <div className="min-w-0">
                  <h2 className="text-xl font-bold text-stone-900">{s.title}</h2>
                  <p className="mt-2 text-stone-700 leading-relaxed">{s.body}</p>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Legal;
